// usage: log('inside coolFunc', this, arguments);
// paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function () {
    log.history = log.history || [];
    log.history.push(arguments);
    if (!window.console) {
        return;
    }
    var args = [].slice.call(arguments);
    if (typeof console.log === 'object') {
        log.apply.call(console.log, console, args);
    } else {
        console.log.apply(console, args);
    }
};

// make it safe to use console.log always
(function (a) {
    function b() {}
    for (
        var c =
                'assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn'.split(
                    ',',
                ),
            d;
        !!(d = c.pop());

    ) {
        a[d] = a[d] || b;
    }
})(window.console || (window.console = {}));
